export default __webpack_public_path__ + "static/media/day-6.e95f952f.jpg";